/* eslint-disable import/prefer-default-export */
export class DeepLinkMappings {
  static linkTarjetaDigital = 'tarjetadigital';

  static linkAhorros = 'ahorros';

  static linkTravel = 'travel';

  static linkSaldo = 'saldo';

  static linkMisDatos = 'misdatos';

  static linkTickets = 'tickets';

  static linkCupones = 'cupones';

  //  static CAMBIO_MAIL = 'change-mail';
  static deepLinkEmailAcces = 'verifyChangeEmailAccessDeepLink';

  static deepLinkEmailComunicacion = 'verifyChangeEmailComunicacionDeepLink';

  //   static BAJA_DIGITAL = 'baja-digital';
  static deepLinkMisDatosBaja = 'misdatosBajaDeepLink';

  // falta conversion al front
  static deepLinkEmailComercial = 'deepLinkEmailComercial';

  static deepLinkFolletos = 'deepLinkFolletos';

  static deepLinkJuegaYGana = 'deepLinkJuegaYGana';

  static deepLinkFolletosEU = 'deepLinkFolletosEU';

  static deepLinkJuegaYGanaEU = 'deepLinkJuegaYGanaEU';

  static deepLinkEscaner = 'deepLinkEscaner';

  static deepLinkEscanerEU = 'deepLinkEscanerEU';

  static deepLinkTiendas = 'deepLinkTiendas';

  static deepLinkTiendasEU = 'deepLinkTiendasEU';

  static deepLinkReportClub = 'deepLinkReportClub';

  static deepLinkReportClubEU = 'deepLinkReportClubEU';

  static deepLinkPlanificador = 'deepLinkPlanificador';

  static deepLinkPlanificadorEU = 'deepLinkPlanificadorEU';

  static linkPromociones = 'promociones';

  static linkMasPromociones = 'maspromociones';

  static linkListadoDeLaCompra = 'listadelacompra';

  static linkHome = 'home';

  static linkVerifyEmail = 'verifyEmailDeepLink';

  static deepLinkMisdatos = 'deepLinkMisdatos';

  static deepLinkNlrLogin = 'nlrLoginDeepLink';

  static deepLinkRecoverEmail = 'recoverEmailDeepLink';

  static linkAvisoCambioClave = 'avisoCambioClave';

  static deepLinkBienvenida = 'deepLinkBienVenida';
}
